import { VehicleStatusCD } from '../../../shared/enum/base.enum';
export interface IRole {
    admin: number;
    sender_Receiver: number;
    sub_Admin: number;
    delivery_Associate: number;
}
export class BusinessModel {
    userId: number;
    businessTypeCD: number;
    businessName: string;
    businessEmail: string;
    businessMobileNo: string;
    userUId: string;
    businessTypeCDUId: string;
    businessTypeName: string;
}
export class AppointmentModel{
    id: number;
    uId: string;
    firstName: string;
    apponintment: string;
    code:string;
    email: string;
    mobileNo: string;
    isShow: boolean;
    fatherLastName: string;
    motherLastName: string;
    comments:string;
    createdDateTime: Date | string ;
    isActive: boolean;
    isFilledAllRequiredField: boolean = true;
    
}

export class UserModel {
    id: number;
    uId: string;
    firstName: string;
    address: string;
    addressProofURL: string;
    lastName: string;
    email: string;
    mobileNo: string;
    userPwd: string;
    confirmPwd: string;
    userTypeCD: number;
    gender: string;
    countryId: number;
    cityId: number;
    isOnline: boolean;
    userStatusCD: number;
    userPhaseStatusCD: number;
    userPhaseStatusName: string;
    subscribePromoOffers: boolean;
    userClassCD: number;
    roleId: number;
    referralCode: string;
    referredBy: string;
    loginFailedAttempt: number;
    emailOTP: string;
    mobileOTP: string;
    registrationDate: Date | string;
    otpExpiryTime: string;
    resendOTPAttempt: number;
    resetPasswordAttempt: number;
    resetPasswordAttemptDate: string;
    isEmailVerified: true;
    isMobileVerified: true;
    countryUId: string;
    userTypeCDUId: string;
    stateUId: string;
    cityUId: string;
    countryName: string;
    departmentName: string;
    designationName: string;
    cityName: string;
    stateName: string;
    isShow: boolean;
    genderCD: number;
    genderCDName: string;
    userStatusCDUId: string;
    userClassCDUId: string;
    userStatusCDName: string;
    userPhaseStatusCDName:string;
    departmentUId: string;
    currentLocationLat: number;
    currentLocationLon: number;
    professionUId: string;
    designationUId: string;
    profilePicURL: string;
    userTypeName: string;
    isTestUser: boolean;
    fatherLastName: string;
    isPetFriendly: boolean;
    isVooyPink: boolean;
    vooyfarmaDriver: boolean;
    motherLastName: string;
    isChecked: boolean = false;
    fullName: string;
    expiryDocumentCount: number;
    createdDateTime: Date | string ;
    addressApproval: string | boolean;
    adressRemark: string;
    totalRides: number;
    rideAvgRating: number;
    totalShipments: number;
    shipmentAvgRating: number;
    totalFoodOrders: number;
    foodAvgRating: number;
    userServices: any;
    addressApprovalCD: number;
    canActivate: boolean;
    isActive: boolean;
    userBusiness: BusinessModel = new BusinessModel();
    billingInfo: BillingModel = new BillingModel();
    isEdit : boolean;
    dialCode:string;
    VehiclePlateNumber:string;
    display: boolean;
    imageSrc: string;
}

export class UserTaxModel {
    userBillingInfo : BillingModel = new BillingModel();
    attachmentConfigurations: Array<AttachmentConfigurationModel> = [];
    taxConfigurations: Array<AttachmentConfigurationModel> = [];
}

export class BillingModel {
    approvalStatus: string;
    approvalStatusCD: number;
    businessAddress: string;
    businessName: string;
    createdBy: number;
    createdDateTime: string;
    id: number;
    interiorNumber: string;
    isActive: boolean;
    modifiedBy: number;
    modifiedDateTime: string;
    municipality: string;
    outdoorNumber: string;
    postalcode: string;
    remarks: string;
    rfc: string;
    suburb: string;
    town: string;
    uId: string;
    userId: number;
    userUId: string;
    countryName : string;
    countryUId : string;
    stateUId : string;
    cityUId : string;
    stateName : string;
    cityName : string;
    showBilling:boolean;
}

export class UserDetailModel {
    data: Array<UserModel> = [];
    totalRecords: number;
}

export class UserDTO {
    user: UserModel = new UserModel();
    modules: Array<ModuleModel> = [];
    statusRemark: string;
    scheduleEndTime: string;
    scheduleStartTime: string;
    slotDurationInMinute: number;
    registrationPhase: UserRegistrationModel = new UserRegistrationModel();
    personalDocuments: Array<AttachmentConfigurationModel> = [];
    vehiclePhysicalReview: VehicleReviewModel = new VehicleReviewModel();
    examStatuses : Array<ExamStatusDTO> = [];
    userServices : Array<UserServiceModel>
    profilePicConfiguration : AttachmentConfigurationModel = new AttachmentConfigurationModel();
}

export class ExamStatusDTO {
    categoryUId : string;
    vehicleTypeCode: string;
    examCompleted:boolean;
    examStatusCD:string;
    examRemainingAttempt: number;
}

export class VehicleReviewModel {
    comment: string;
    createdBy: number;
    createdDateTime: string;
    id: number;
    isReviewed: boolean;
    modifiedBy: number;
    modifiedDateTime: string;
    reviewDate: string;
    reviewStatus: string;
    reviewStatusCD: number;
    scheduledDate: string | Date;
    startTime: string;
    endTime: string;
    timeRange: string;
    uId: string;
    userId: number;
    userUId: string;
    isReschedule: boolean;
}
export class UserRegistrationModel {
    createdBy: number;
    createdDateTime: string;
    id: number;
    modifiedBy: number;
    modifiedDateTime: string;
    phase1Enabled: boolean;
    phase2Enabled: boolean | string;
    phase3Enabled: boolean | string;
    phase4Enabled: boolean | string;
    phase2Enable: boolean | string;
    phase3Enable: boolean | string;
    phase4Enable: boolean | string;
    uId: string;
    userId: number;
    userUId: string;
    currentPhase: number;
}

export class RegistrationApprovalModel {
    expiryDate: Date | string;
    rejectedReason: string;
    header: string;
    isFilledAllRequiredField: boolean = true;
    approveDocument: boolean;
    visible: boolean;
    minDate: Date;
    attachmentUID: string;
    msg : string;
    attachmentTypeCD: number;
    isExpiryDateExtended: boolean;
}

export class UserVehicleModel {
    id: number;
    uId: string;
    userId: number;
    vehicleTypeCD: number;
    model: string;
    registrationYear: number;
    vehicleMakerId: number;
    vehicleName: string;
    vehicleRegistrationNo: string;
    vehicleStatusCD: number;
    remarks: string;
    status: string;
    isActive: boolean;
    userUId: string;
    vehicleTypeCDUId: string;
    vehicleMakerUId: string;
    vehicleTypeCDName: string;
    vehicleMakerName: string;
    configCDUId: string;
    isEdit:boolean;
}


export class VehicleModel {
    countryId: string;
    defaultVehicleImage: string;
    engineNumber: string;
    expiryDate: string | Date;
    vehicleExpiryDate: string | Date;
    fuelTypeId: number;
    fuelTypeName: string;
    id: number;
    isActive: boolean;
    isEnable: boolean;
    languageCode: string;
    model: string;
    ownerName: string;
    plateNumber: string;
    registrationYear: any;
    remarks: string;
    serialNumber: string;
    serviceTypeId: number;
    status: string;
    uId: string;
    userId: number;
    userUId: string;
    year : number;
    vehicleBrandId: number;
    vehicleBrandName: string;
    vehicleBrandUId: string;
    vehicleCategoryIds: Array<any> = [];
    vehicleCategoryName: string;
    vehicleCode: string;
    vehicleStatusCD: number;
    vehicleSubBrand: string;
    vehicleTypeCode: string;
    vehicleTypeId: number;
    vehicleTypeName: string;
    vehicleTypeUId: string;
    vehicleUse: string;
    vehicleUseId: number;
    vehicleUseUId: string;
    vehicleColorCDName: string;
    isOtherMobilityApplication: boolean = true;
    vehicleCategoryShipmentId: number;
    vehicleCategoryRideId: number;
    isPetFriendly: boolean;
    isRecieveCertification: boolean;
    isVooyPink: boolean;
    isSpecialAbility : boolean;
    attachments: Array<AttachmentModel> = [];
    userVehicleCategories: Array<UserVehicleCategoryModel> = []
    isEdit:boolean
    vehicleColorCD:number
}

export class UserVehicleCategoryModel {
    availableSeats: number;
    availableRideSeats: number;
    currentWeight: number;
    displayOrder: number;
    id: number;
    availableWeight: number;
    maxHeightCm: number;
    maxLengthCm: number;
    maxRangeInKm: number;
    maxWeightKg: number;
    maxWidthCm: number;
    serviceTypeId: number;
    serviceTypeName: string;
    totalSeats: number;
    userVehicleId: number;
    vehicleCategoryId: number;
    vehicleCategoryName: string;
    vehicleTypeCode: string;
    label: string;
    value: number;

}

export class VehicleConfigurationModel {
    userVehicle: VehicleModel = new VehicleModel();
    attachmentConfigurations: Array<AttachmentConfigurationModel> = [];
    vehicleMobilityApps: Array<AttachmentConfigurationModel> = [];
    userServices: Array<any> = [];
}

export class VehicleTypeModel {
    id: number;
    uId: string;
    countryId: number;
    displayOrder: 1;
    code: string;
    name: string;
    name_es_mx: null;
    serviceCharge: string;
    isActive: boolean= false;
    createdDateTime: string;
    modifiedDateTime: string;
    countryName: string;
    currencyCode: string;
    maxHeightCm: number;
    maxLengthCm: number;
    maxWidthCm: number;
    maxWeightInKG:number;
    maxRangeInKM: number;
    isValidDimension:boolean =false;
    label : string;
    value : string;
}
export class FuleTypeModle{
    id: number;
    vehicleTypeId: number;
    fuelName: string;
    fuelName_es_mx: null;
    isActive:boolean = true;
    createdDateTime: string;
    modifiedDateTime: string;
    vehicleTypeUId:string;
    vehicleTypeCode: string;
    label : string;
    value :number;
}
export class VehicleBrandModel{
    id: number;
    name: string;
    countryId: number;
    vehicleTypeId: number;
    isActive: boolean = true
    countryUId: string;
    countryName: string;
    countryCode: string;
    label : string;
    uId : string;
    value : string;
}
export class VehicleColorModel{
    id: number;
    uId: string;
    configCDGroupId:number
    cdValue:string;
    cdDesc: string;
    displayOrder: number;
    cdValue_es_mx: null;
    cdDesc_es_mx: null;
    isActive:boolean=true;
    createdDateTime: string;
    modifiedDateTime: string;
    isForRide: boolean=false;
    label : string;
    value :number;
}

export class VehicleMobilityModel {
    attachmentConfigurationId: number;
    attachmentConfigurationUId: string;
    attachmentUId: string;
    id: number
    uId: string;
    userId: number
    userVehicleId: number;
}

export class VehicleDocumentModel {
    tableUIdValue: string = '';
    attachmentUId: string = '';
    expiryDate: Date | string;
    remark: string;
    isShow: boolean;
    minDate: Date;
    isApproved : boolean;
    msg : string;
    isExpiryDateExtended: boolean;
}


export class VehicleCategoryTypeModel {
    id: number;
    uId: string;
    vehicleTypeId: number;
    serviceTypeId: number;
    displayOrder: number;
    logoUrl: string;
    name: string;
    name_es_mx: string;
    baseFare: number;
    ratePerKm: number;
    ratePerMin: number;
    bookingFee: number;
    minFare: number;
    waitChargePerMin: number;
    applyWaitChargeAfterInMin: number;
    maxWeightKg: number;
    maxLengthCm: number;
    maxWidthCm: number;
    maxHeightCm: number;
    maxRangeInKm: number;
    totalSeats: number;
    isActive: boolean;
    countryName: string;
    countryUId: string;
    vehicleTypeName: string;
    serviceTypeName: string;
    currencyCode: string;
    label: string;
    value: number;
}

export class VehicleStatusModel {
    cdDesc: string;
    cdDesc_es_mx: string;
    cdValue: string;
    cdValue_es_mx: string;
    configCDGroupId: number;
    createdDateTime: string;
    displayOrder: number;
    id: number
    isActive: boolean
    isForRide: boolean
    label: string;
    modifiedDateTime: string;
    uId: string;
    value: string;
}

export class BankStatusModel {
    cdDesc: string;
    cdDesc_es_mx: string;
    cdValue: string;
    cdValue_es_mx: string;
    configCDGroupId: number;
    createdDateTime: string;
    displayOrder: number;
    id: number
    isActive: boolean
    isForRide: boolean
    label: string;
    modifiedDateTime: string;
    uId: string;
    value: string;
}

export class ViewVehicleComponentModel {
    vehicleUid: string;
    userUid: string;
    vehicleStatus: number;
    display: boolean;
    imageSrc: string;
    showButtons: boolean;
    vehicleCategoryId: number;
    header: string;
    showRide: boolean;
    showShipment: boolean;
    show: boolean;
    minDate: Date;
    event: any;
    visible: boolean;
    expiryDate: Date | string;
    rejectReason: string;
    approveVehicle: boolean;
    vehicleStatusCD: number = VehicleStatusCD.ReviewInProcess;
    isFilledAllRequiredField: boolean = true;
}


export class AttachmentModel {
    id: number;
    tableIdValue: number;
    attachmentConfigurationId: number;
    fileName: string;
    filePath: string;
    attachmentTableId: number;
    apiUrl: string;
    attachmentUrl: string;
    thumbnailAttachmentUrl: string;
    contentType: string;
    tableUIdValue: string;
    title: string;
    description: string;
    isApproved: boolean;
    attachmentConfigurationUId: string;
    attachmentTypeCD: number;
    uId: string;
    isActive: boolean;
}

export class AttachmentConfigurationModel {
    id: number;
    uId: string;
    tableIdValue: number;
    attachmentId: number;
    fileName: string;
    filePath: string;
    logoUrl: string;
    attachmentTableId: number;
    attachmentRemark: string;
    attachmentUrl: string;
    thumbnailAttachmentUrl: string;
    contentType: string;
    tableUIdValue: string;
    fileUrl : string;
    title: string;
    userUId : string;
    code : string;
    description: string;
    attachmentUId: string;
    displayOrder: number;
    fileType: string;
    isAttachment: boolean;
    fileSystemProvider: string;
    attachmentTypeCD: number;
    countryId: number;
    countryUId: string;
    attachmentTypeCDUId: string;
    attachmentTypeCDValue: string;
    attachmentConfigurationUId: string;
    countryName: string;
    titleValue: string;
    oldTitleValue: string;
    apiUrl: string;
    identityStatusCD: number;
    isApproved: boolean;
    isSelected: boolean;
    remark: string;
    isShow: boolean;
    expiryDateTime: any;
    expiryDate: string | Date;
    identityStatusCDName: string;
    isFileUploaded : boolean;
    userVehicleUId : string;
    curpValue : string;
    showCurpValue : boolean;
    isCurpValid : boolean;
    label: string;
    value: string;
    isDocumentExpired: boolean;
}

export class BankModel {
    id: number;
    uId: string;
    accHolderName: string;
    accountNumber: string;
    bankCode: string;
    address: string;
    bankName: string;
    cityId: number;
    zipCode: string;
    isDefault: boolean | string;
    bankConfigurationId: number;
    bankStatusCD: number;
    userId: number;
    remarks: string;
    isActive: boolean | string;
    isSelected: boolean | string;
    cityUId: string;
    bankConfigurationUId: string;
    userUId: string;
    bankStatus: string;
    cityName: string;
    stateUId: string;
    countryUId: string;
    countryName: string;
    stateName: string;
    status: string;
    isShow: boolean;
    fullAddress: string;
    taxIDNumber: string;
    isFilledAllRequiredField: boolean = true
    canEditBankInfo : boolean = false;
}

export class UserPermissionModel {
    id: number;
    userId: number;
    modulePermissionId: number;
    hasPermission: boolean;
    userUId: string;
    subModuleName: string;
    permissionName: string;
    permissionLabel: string;

    moduleName: string;
    moduleId: number;
}
export class ModuleModel {
    id: number;
    hasPermission: boolean;
    moduleName: string;
    userPermissions: Array<UserPermissionModel>;
    subModuleName: string;
    menuLinkName: string;
    fullModuleName: string;
}


export class DepartmentModel {
    id: number;
    uId: string;
    name: string;
    isActive: boolean;
    label: string;
    value: string;
}

export class AddStaffModel {
    staffUid: string;
    showButtons: boolean = true;
    country: any;
    display: boolean;
    imageSrc: string;
    roleId: number;
    header: string;
    documentList = [];
    statusRemark: string;
    genderList = [];
    countryCode: string = '+52';
    isFilledAllRequiredField: boolean = true;
    isStateShow: boolean = true;
    isCityShow: boolean = true;
    isShow: boolean;
    showBlock: boolean = true;
    showUnsubscribe: boolean = true;
}

export class ApproveModel {
    id: number;
    uId: string;
    userId: number;
    attachmentConfigurationId: number;
    identityValue: string;
    identityStatusCD: number;
    remark: string;
    attachmentConfigurationUId: string;
    title: string;
    description: string;
    attachmentTypeCD: number;
    attachmentTypeCDName: string;
    isAttachment: boolean;
    userUId: string;
}

export class StatusModel {
    id: number;
    uId: string;
    configCDGroupId: number;
    cdValue: string;
    cdDesc: string;
    displayOrder: number;
    isActive: boolean;
    label: string;
    value: string;
    // userePhaseStatusCD:number;
   
}

export class GenderModel {
    id: number;
    uId: string;
    configCDGroupId: number;
    cdValue: string;
    cdDesc: string;
    displayOrder: number;
    cdValue_es_mx: number;
    cdDesc_es_mx: number;
    isActive: boolean;
    createdDateTime: string;
    modifiedDateTime: string;
    isForRide: boolean;
    label: string;
    value: number;
}

export class UserServiceModel {
    id: number;
    userId: number;
    serviceTypeId: number;
    isOpted: boolean;
    isOnline: boolean;
    isEnable: boolean;
    isBlocked: boolean | string;
    blockedStatus: boolean | string;
    remark: string;
    isShow: boolean;
    hourFrom: string;
    hourTo: string;
    serviceTypeName: string;
    createdDateTime: string | Date;
    showCreatedTime: string | Date;
    userServiceBlockedHistory: Array<UserServiceBlockedModel> = [];
    label: string;
    value: number;
}

export class UserServiceBlockedModel {
    id: number;
    userServiceId: number;
    isBlocked: boolean;
    blockReason: string;
    isUnBlock: boolean;
    unBlockReason: string;
    createdDateTime: string | Date;
    showCreatedTime: string | Date;
    modifiedDateTime: string | Date;
    showModifiedTime: string | Date;

}

export class CategoryModel {
    name: string;
    value: number;
    serviceTypeId: number;
    uId: string;
    categories: Array<any> = [];
    isChecked: boolean;
    vehicleCategoryUId: string;
    id: number;
}

export interface IUserStatus {
    Registered: number,
    ReviewInProcess
        Approved: number,
    Rejected: number,
    Blocked: number,
    Suspended: number,
    Deleted: number
     PermanentlyDeleted: number;
    Phase1ReviewinProcess:number;
    Phase2ReviewinProcess:number,
    Phase3ReviewinProcess:number,
    Phase4ReviewinProcess:number,
    Phase1Approved:number,
    Phase2Approved:number,
    Phase3Approved:number,
    Phase4Approved:number,
    Phase1Registered:number,
    Phase2Registered:number,
    Phase3Registered:number,
}

export class StaffSearchModel {
    fullName: string;
    fatherLastName:string;
    motherLastName:string;
    VehiclePlateNumber: string;
    uId: string;
    email: string;
    mobileNo: string;
    userPhaseStatusCDUId:string;
    userStatusCDUId: string = undefined;
    bankStatusCDUId: string = undefined;
    vehicleStatusCDUId: string = undefined;
    designationUId: string = undefined;
    departmentUId: string = undefined;
    countryUId: string = undefined;
    stateUId : string = undefined;
    cityUId : string = undefined;
    documentValidityType: number = 0;
    vehicleUId: string;
    bankUId: string;
    isStaffSearch: boolean = true;
    roleId: number;
    serviceType: number;
    timezoneOffset: string;
    fromDate: string;
    toDate: string;
}

export class VehicleSearchModel {
    userUid: string;
    vehicleUId: string;
    vehicleModel: string;
    vehicleType: string;
    plateNumber: string;
    vehicleRegistrationYear: number;
    vehicleStatus: string;
    vehicleEnable: string;
    vehicleColor: string
    isVehicleSearch: boolean = true;
}

export class BankFilterModel {
    userUId: string;
    bankUId: string;
    accountHolderName: string;
    accountNumber: string;
    bankDefault: string;
    bankStatus: string;
    isBankSearch: boolean = true;
}

export class CalenderModel {
    firstDayOfWeek: number;
    dayNames: Array<any> = [];
    dayNamesShort: Array<any> = [];
    dayNamesMin: Array<any> = [];
    monthNames: Array<any> = [];
    monthNamesShort: Array<any> = [];
    today: string;
    clear: string;
    dateFormat: string;
    weekHeader: string;
}

export class DriverServiceModel {
    uId: string;
    orderNumber: string;
    driverName: string
    driverUId: string;
    totalAmount: number;
    currencyCode: string;
    orderDate: string | Date;
    paymentMode: string;
    customerName: string;
    customerUId: string;
    daRatingValue: number;
    daComment: string;
    ratingUId: string;
    orderStatusCd: number;
    orderStatus: string;
    carrierName: string;
    deliveryMode: string;
    isChecked: boolean = false;
}

export class PartnerServiceModel {
    data: Array<DriverServiceModel> = [];
    totalRecords: number;
    overdue: number;
}

export class DriverRatingModel {
    id: number;
    uId: string;
    orderId: number;
    ratingValue: number;
    rating: number;
    comment: string;
    remarks: string;
    defaultReview: string;
    givenToUserId: number;
    isActive: boolean;
    createdBy: number;
    createdDateTime: string;
    orderUId: string;
    userName: string;
    avgReview: number;
    isShow: boolean;
    reviewMasterUIds: Array<any> = [];
}

export class DriverEditor{
 firstName : string;
 name: string;
 lastName: string;
 fatherLastName:string;
 motherLastName:string;
 email:string;
 mobile:string;
 gender:string;
 userPwd:string;
 confirmPwd:string;
 genderCD:number;
 isVooyPink: boolean;
 profilePicURL:string;
 dialCode:string;
 stateUId: string;
 cityUId: string;
 countryUId:string;
 genderList = [];
 display: boolean;
 imageSrc: string;
 mobileNo: string;
 timeZone: string;
}

export class ReferredUserModel{
    name: string;
    fatherLastName: string;
    motherLastName: string;
    email: string;
    mobileNumber: string;
    partnerCode: string;
    status: string;
    numberOfTrips: number;
    startDate: Date | string;
    endDate: Date | string;
    remainingDays: number;
    totalTrips: number;
    numberOfTripsOverTotalTrips: string;
}

export class ModificationDetailsModel{
    firstName: string;
    lastName: string;
    status: string;
    modificationDate: string | Date;
    remark: string;
    modifyBy: string;
}

export class UserSubscriptionDTO {
    isSubscriptionActive: boolean;
    reason: string;
    isTrialPeriod: string;
    trialEndDate: string;
    subscriptionStatus: string;
    subscriptionEndDate: string;
  
}

export class UserDataResponse {
    userDetail: UserDTO;
    subscriptionDetail: UserSubscriptionDTO;
  
    constructor(userDetail: UserDTO, subscriptionDetail: UserSubscriptionDTO) {
      this.userDetail = userDetail;
      this.subscriptionDetail = subscriptionDetail;
    }
}
  
  